



<div class="redirectToLogin" >
   <span class="redirect" routerLink="/greetings"> <a>© Copyright 2020-2045 JDK &amp; LLYN. All Rights Reserved.</a></span>
  </div>